import React from "react";
import { motion, useScroll, useSpring } from "framer-motion";
import useMotionGuard from "../hooks/useMotionGuard";

/**
 * Barra di progresso scroll fissa in cima alla pagina.
 * Attiva anche su touch (non dipende dal puntatore), disattiva solo su prefers-reduced-motion.
 */
export default function ScrollProgress() {
    const { reduced } = useMotionGuard();
    const { scrollYProgress } = useScroll();
    const scaleX = useSpring(scrollYProgress, {
        stiffness: 120,
        damping: 24,
        mass: 0.4,
        restDelta: 0.001,
    });

    if (reduced) return null;

    return (
        <motion.div
            className="lp-scroll-progress"
            aria-hidden="true"
            style={{ scaleX }}
            data-testid="scroll-progress"
        />
    );
}
